import {
	bindQueryClient,
	type InvalidatingQueryClient,
	RealtimeClient,
	STAFF_INVALIDATIONS,
	STAFF_LIVE_KEYS,
	type StaffAuth,
} from "@luckymenu/realtime-client";
import type { RealtimeAdapter } from "../adapters";

/**
 * The staff app's socket (realtime-notifications.md): one client per app,
 * authenticated with the Clerk token, the active restaurant and a support
 * token like every API call. Each event invalidates the staff queries it
 * touches, a reconnect refetches the live screens, and while offline they
 * are polled every 15 seconds.
 */
export function createStaffRealtime(
	adapter: RealtimeAdapter,
	queryClient: InvalidatingQueryClient,
	getAuth: () => Promise<StaffAuth | null>,
): RealtimeClient {
	const client = new RealtimeClient({
		url: adapter.url,
		getAuth,
		...(adapter.createSocket ? { createSocket: adapter.createSocket } : {}),
	});
	bindQueryClient(client, queryClient, {
		invalidations: STAFF_INVALIDATIONS,
		liveKeys: STAFF_LIVE_KEYS,
	});
	return client;
}
